import { Box, Switch, styled } from '@chronosphereio/chrono-ui';

export interface ContentWithLegendGroupByProps {
  /**
   * When true, a switch to toggle the group by feature is shown.
   */
  show: boolean;
  /**
   * State of the group by switch.
   */
  isGrouped: boolean;
  /**
   * Callback when the state of the group by switch changes.
   */
  onChange?: (isGrouped: boolean) => void;
  /**
   * Label to be shown with the group by switch.
   */
  label?: string;
}

export function ContentWithLegendGroupBy({ show, isGrouped, onChange, label }: ContentWithLegendGroupByProps) {
  if (!show) {
    return null;
  }

  return (
    <ContentWithLegendGroupByRoot>
      <Switch
        label={label}
        checked={isGrouped}
        onChange={(e, checked) => {
          onChange?.(checked);
        }}
      />
    </ContentWithLegendGroupByRoot>
  );
}

const ContentWithLegendGroupByRoot = styled(Box)(({ theme }) => {
  return {
    // Avoids the label wrapping.
    whiteSpace: 'nowrap',
    // Undoes the right margin on the Switch label, so that the gap spacing in the `ContentWithLegendToolbar`
    // is used.
    marginRight: theme.spacing(-2),
  };
});
